module.exports = __webpack_public_path__ + "img/socio5.28dba979.png";